import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { featureFlagsApi } from '../api/client';
import type { FeatureFlag } from '../api/client';

const PLATFORM_KEY = 'platform-feature-flags';
const TENANT_KEY = 'tenant-feature-flags';

export function usePlatformFeatureFlags() {
  return useQuery<FeatureFlag[], Error>({
    queryKey: [PLATFORM_KEY],
    queryFn: () => featureFlagsApi.listPlatform(),
  });
}

export function useUpdatePlatformFeatureFlags() {
  const queryClient = useQueryClient();
  return useMutation<FeatureFlag[], Error, Record<string, boolean>>({
    mutationFn: (updates) => featureFlagsApi.updatePlatform(updates),
    onSuccess: (data) => {
      queryClient.setQueryData<FeatureFlag[]>([PLATFORM_KEY], data);
      queryClient.invalidateQueries({ queryKey: [PLATFORM_KEY] });
    },
  });
}

export function useTenantFeatureFlags(tenantId: string | undefined) {
  return useQuery<FeatureFlag[], Error>({
    queryKey: [TENANT_KEY, tenantId],
    queryFn: () => featureFlagsApi.listTenant(tenantId as string),
    enabled: !!tenantId,
  });
}

export function useUpdateTenantFeatureFlags(tenantId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation<FeatureFlag[], Error, Record<string, boolean>>({
    mutationFn: (updates) => featureFlagsApi.updateTenant(tenantId as string, updates),
    onSuccess: (data) => {
      queryClient.setQueryData<FeatureFlag[]>([TENANT_KEY, tenantId], data);
      queryClient.invalidateQueries({ queryKey: [TENANT_KEY, tenantId] });
    },
  });
}
